var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIslamic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2936_6008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6528 17.0001C12.6527 13.4701 14.05 10.0837 16.5392 7.58081C19.0284 5.07795 22.4072 3.66218 25.9371 3.64293C23.5488 2.13872 20.8009 1.30235 17.9796 1.22093C15.1583 1.1395 12.3668 1.816 9.89579 3.17996C7.42477 4.54392 5.36463 6.54545 3.92995 8.9761C2.49527 11.4067 1.73853 14.1776 1.73853 17.0001C1.73853 19.8225 2.49527 22.5934 3.92995 25.024C5.36463 27.4547 7.42477 29.4562 9.89579 30.8202C12.3668 32.1842 15.1583 32.8606 17.9796 32.7792C20.8009 32.6978 23.5488 31.8614 25.9371 30.3572C22.4072 30.338 19.0284 28.9222 16.5392 26.4193C14.05 23.9165 12.6527 20.53 12.6528 17.0001Z",
    stroke: "#25A249",
    strokeWidth: 2.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6698 9.81152L27.8798 14.2072H32.2755L28.9727 17.6072L30.0169 22.4644L25.6698 20.0358L21.5169 22.4644L22.3912 17.6072L19.0884 14.2072H23.4841L25.6698 9.81152Z",
    stroke: "#25A249",
    strokeWidth: 2.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2936_6008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIslamic);
export default __webpack_public_path__ + "static/media/islamic.c53d13624f1b9d3151c1b5a435abb29c.svg";
export { ForwardRef as ReactComponent };